import { useEffect, useState } from "react";
import RecentChangesTable from "../SharedComponents/RecentChangesTable";
import Approvals from "../SharedComponents/Approvals";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import Button from "components/lib/Shared/Button";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import {
  getTransactionChangeByBatchNumberAsync,
  getTransactionChangeByIdAsync,
} from "state/slices/initiateTransactionChange";
import { useToast } from "hooks/useToast";
import { resetBatchNumber } from "state/slices/batchNumber";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ValidateTransactionSchema } from "utils/validateTransactionSchema";

const RecentChangesAndApprovals = (props) => {
  const companyDashboardSlice = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { toast } = useToast();
  const [selectedStep, setselectedStep] = useState("changesTable");
  const { trxId, companyId } = useParams();
  const [isValidating, setIsValidating] = useState(false);
  const [transactionToEdit, setTransactionToEdit] = useState(null);
  const [batchedTransactions, setBatchedTransactions] = useState([]);
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.companyDashboardSlice);

  const handleGoBack = () => {
    if (selectedStep === "approvals") {
      setselectedStep("changesTable");
    } else {
    }
  };

  const handleNextStep = async () => {
    setIsValidating(true);
    try {
      const validationResult = ValidateTransactionSchema(
        company,
        transactions,
        companyDashboardSlice
      );
      const hasInvalidTransaction = validationResult.validationResults.some(
        (result) => !result.isValid
      );
      const hasGovernanceIssues =
        !validationResult.governanceValidation.isValid;
      if (hasInvalidTransaction || hasGovernanceIssues) {
        const errorMessages = [
          ...validationResult.validationResults
            .filter((result) => !result.isValid)
            .map((result) => result.message),
          ...validationResult.governanceValidation.messages,
        ].join("\n");
        toast("error", errorMessages);
        setIsValidating(false);
        return;
      }
      dispatch(resetBatchNumber());
      setselectedStep("approvals");
    } catch (error) {
      toast("error", "Validation failed. Please try again.");
    } finally {
      setIsValidating(false);
    }
  };

  const initiateNewRequest = () => {
    props.handleInitiateNewRequest();
  };

  useEffect(() => {
    window.localStorage.removeItem("trxRef");
  }, []);

  useEffect(async () => {
    if (!transactionToEdit) {
      const response = await dispatch(getTransactionChangeByIdAsync({ trxId }));
      if (response.payload.status) {
        setTransactionToEdit(response.payload.retrievedTransactions);
      }
    }
  }, [trxId]);

  useEffect(async () => {
    if (transactionToEdit && transactionToEdit?.batchNo) {
      const response = await dispatch(
        getTransactionChangeByBatchNumberAsync({
          batchNo: transactionToEdit.batchNo,
        })
      );
      setBatchedTransactions(response.payload.items);
    }
  }, [transactionToEdit]);

  const transactions =
    batchedTransactions?.length > 1 ? batchedTransactions : [transactionToEdit];

  return (
    <CompanyDashboardWrapper>
      <div>
        <div>
          {selectedStep === "changesTable" && transactionToEdit && (
            <RecentChangesTable
              handleGoBack={handleGoBack}
              handleInitiateNewRequest={initiateNewRequest}
              data={transactions}
            />
          )}
          {selectedStep === "approvals" && (
            <Approvals
              approvalComponentsCallBack={handleGoBack}
              transactions={transactions}
            />
          )}
        </div>
        {selectedStep !== "approvals" && (
          <div className="flex justify-between mt-4">
            <Link
              to={`/companies/${companyId}/dashboard/transactions/${trxId}/edit`}
            >
              <button
                type="button"
                onClick={() => null}
                className="flex items-start float-right py-2 font-semibold rounded text-primary"
              >
                <span className="flex items-center mr-4 h-7">
                  <ChevronLeftIcon
                    className="flex-shrink-0 w-5 h-5"
                    aria-hidden="true"
                  />
                </span>
                <p className="font-semibold"> Go back</p>
              </button>
            </Link>
            <Button
              className="float-right mt-2"
              type="button"
              onClick={handleNextStep}
              disabled={isValidating}
            >
              {isValidating ? (
                <>
                  <SpinnerIcon className="w-5 h-5 mr-2 text-white animate-spin" />
                  Validating...
                </>
              ) : (
                "Proceed to Approvals"
              )}
            </Button>
          </div>
        )}
      </div>
    </CompanyDashboardWrapper>
  );
};

export default RecentChangesAndApprovals;
